


<template>
  <v-data-table
  fixed-header
    :items-per-page="-1"
    hide-default-footer
    single-select
    sort-by="timeStamp"
    :sort-desc="true"
    :height="viewPortHeight / 2"
    :loading="loading"
    :headers="analysisHeader"
    :items="analysisList"
    :expanded.sync="expanded"
    item-key="id"
    single-expand
    show-expand
    >
    <template v-slot:item.result.answers[0]="{ item }">
      <v-chip dark small :color="getColor(getTopAnswer(item))">
        <span v-if="getTopAnswer(item).score !== null">
          {{ getTopAnswer(item).score }}
        </span>
        <span v-else-if="getTopAnswer(item).confidenceScore !== null">
        <!-- {{ getTopAnswer(item).confidenceScore }} -->
          {{ 1 * 100 }}
        </span>
        <span v-else>
          {{ 100 }}
        </span>
      </v-chip>
    </template>

    <template v-slot:item.result.answers[0].answer="{ item }">
      {{ getTopAnswer(item).answer | trimLength }}
    </template>

    <template v-slot:item.result.answers[0].questions[0]="{ item }">
      <span v-if="getTopAnswer(item).questions.length > 0">
        {{ getTopAnswer(item).questions[0] | trimLength }}
      </span>
    </template>

    <template v-slot:item.timeStamp="{ item }">
            {{ item.timeStamp | formatDateFromNow }}
        </template>
    
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="py-2">
        <span class="font-weight-medium body-1 primary--text">
          More information:
        </span>
        <v-simple-table dense v-if="item.result && item.result.answers && item.result.answers.length > 0">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Questions</th>
                <th class="text-left">Answers</th>
                <th class="text-left">Score</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, index) in item.result.answers" :key="index">
                <td>
                  <span v-if="it.questions && it.questions.length > 0">
                    {{ it.questions[0] | trimLength }}
                  </span>
                  <span v-else>—</span>
                </td>
                <td>{{ it.answer | trimLength }}</td>
                <td>{{ it.score }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <span v-else>No detailed answer information available.</span>
      </td>
    </template>
    </v-data-table>
</template>

<script>
import moment from "moment";

export default {
  name: "qnaAnalytics",
  props: {
    analysisList: Array,
    loading: Boolean,
  },
  data() {
    return {
         debug: true,
      expanded: [],
      analysisHeader: [
        { text: "Question Asked", align: "start", value: "transcript" },
        // { text: 'Top Response Question', value: 'result.question' },
        { text: "Top Response Answer", value: "result.answer.response" },
        { text: 'Confidence Score', align: '', value: 'result.answers[0]'  },
        { text: "TimeStamp", value: "timeStamp" },
        { text: "More Information", value: "data-table-expand" },
      ],

      // response.answer.response
    };
  },
  computed: {
    viewPortHeight() {
      return window.innerHeight;
    },
  },
  methods: {
    getTopAnswer(item) {
      if (item && item.result && item.result.answers && item.result.answers.length > 0) {
        return item.result.answers[0];
      }
      // Return a safe object with null or default values for robustness
      return { answer: null, score: null, questions: [] };
    },

    getColor(object) {
      let score;
      // Note: The logic for getting the score is good, but the template logic will be updated
      // to rely on the getTopAnswer fallback if no score is found.
      if ("score" in object && object.score !== null) {
        score = object.score;
      } else if ("confidenceScore" in object && object.confidenceScore !== null) {
        score = object.confidenceScore * 100;
      } else {
        // Default to 100 if no score property is found, as requested
        score = 100;
      }
      
      if (score >= 76) {
        return "success";
      } else if (score >= 60) {
        return "amber";
      } else {
        return "error";
      }
    },

    // getColor(object) {
    //   let score;
    //   if ("score" in object) {
    //     score = object.score;
    //   } else {
    //     console.log("Object: ", object);
    //     score = object.confidenceScore * 100;
    //   }
    //   if (score >= 76) {
    //     return "success";
    //   } else if (score >= 60) {
    //     return "amber";
    //   } else {
    //     return "error";
    //   }
    // },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("L");
    },
    formatDuration(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("mm:ss");
    },
    formatTime(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("LT");
    },
    formatStringTime(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("LTS");
    },
    formatDateFromNow(val) {
      if (!val) {
        return "-";
      }

      return moment(val).fromNow();
    },
    trimLength(val) {
      if (typeof val !== "string") return val;
      if (val === null) return val;
      if (val === "") return val;
      if (val.length <= 100) {
        return val;
      }
      return `${val.substring(0, 50)}...`;
    },
  },
  mounted() {
    console.group("🔍 QnA Analysis List");
    this.analysisList.forEach((item, i) => {
      console.log(`Item ${i}:`, item);
      if (!item.result) console.warn(`⚠️ Item ${i} missing 'result'`);
      else if (!item.result.answer)
        console.warn(`⚠️ Item ${i} missing 'result.answers'`);
    //   else if (!item.result.answer.length)
    //     console.warn(`⚠️ Item ${i} has empty 'result.answers'`);
    });
    console.groupEnd();

    // Optional summary table
    // console.table(
    //   this.analysisList.map((item, i) => ({
    //     index: i,
    //     hasResult: !!item.result,
    //     hasAnswers: !!item.result?.answers,
    //     answersCount: item.result?.answers?.length || 0,
    //     firstAnswer: item.result?.answers?.[0]?.answer || "—",
    //     transcript: item.transcript?.slice(0, 40) || "—",
    //     timeStamp: item.timeStamp || "—",
    //   }))
    // );
  },
};
</script>
